import Modal from "../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeViewModal } from "../../store/reducers/frases/frases.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const FraseViewModal = () => {
  const dispatch = useDispatch();

  const {
    viewModalOpen,
    selectedFrase,
    selectedFraseLoading,
    selectedFraseError,
  } = useSelector((state) => state.frases);

  return (
    <Modal
      open={viewModalOpen}
      onClose={() => dispatch(closeViewModal())}
      title="Detalle de la frase"
      size="lg"
    >
      {selectedFraseLoading && (
        <Loader
          center
          text="Cargando información de la frase..."
          delay={150}
          type="dots"
        />
      )}

      {selectedFraseError && (
        <p className="text-danger">{selectedFraseError}</p>
      )}

      {!selectedFraseLoading && selectedFrase && (
        <div className="row g-4">
          {/* Frase - Columna completa */}
          <div className="col-12">
            <Field
              icon="mdi:format-quote-close"
              label="Frase"
              value={selectedFrase.frase}
              justify
            />
          </div>

          {/* Información principal */}
          <div className="col-md-6">
            <Field
              icon="mdi:star-outline"
              label="Talento asociado"
              value={selectedFrase.talento_global_nombre || "Sin talento asociado"}
            />
          </div>

          <div className="col-md-6">
            <Field
              icon="mdi:dice-multiple"
              label="Tipo"
              value={
                <span
                  className={ 
                    selectedFrase.is_random
                     }
                >
                  {selectedFrase.is_random ? "Frase aleatoria" : "Frase normal"}
                </span>
              }
            />
          </div>

          <div className="col-md-6">
            <Field
              icon="mdi:toggle-switch"
              label="Estado"
              value={
                <span
                  className={`badge ${
                    selectedFrase.is_active
                      ? "bg-success-focus text-success-main"
                      : "bg-neutral-200 text-neutral-600"
                  } px-3 py-2`}
                >
                  {selectedFrase.is_active ? "Activo" : "Inactivo"}
                </span>
              }
            />
          </div>

          {/* Información de auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedFrase.created_at}
              updatedAt={selectedFrase.updated_at}
              createdBy={selectedFrase.created_by}
              updatedBy={selectedFrase.updated_by}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default FraseViewModal;
